export class ComponentPriceListEntry {
    public id: number;
    public damageComponentId: number;
    public damageComponent: string;
    public damageArea: string;
    public productId: number;
    public value: number;
    public repairActivityId: number;
    public repairActivity: string;
    public depletionPercentage?: number;

    public customerId: number; // only for url convention, not needed
}
